export const shortUrlEndpointIds = {
    CREATE_SHORT_URL: 'CREATE_SHORT_URL',
    GET_SHORT_URL_STATS: 'GET_SHORT_URL_STATS',
};
